import PipelineDocumentsPage from '../../../components/admin/pipeline/PipelineDocumentsPage'
export default function PipelineDocuments() { return <PipelineDocumentsPage /> }
